import React, { useState } from "react"
import styled from "styled-components"
import parsePhoneNumber from "libphonenumber-js"

import NextImg from "@/common/components/NextImg"
import PanelButton from "./PanelButton"
import DownloadDeepLink from "@/common/assets/image/moneyFortune/Download-DeepLink.svg"
import PhoneInput from "react-phone-input-2"
import { CopyToClipboard } from "react-copy-to-clipboard"
import "react-phone-input-2/lib/material.css"

export default function PanelGetNFT({
  setShowPanel,
  showResult,
  setShowResult,
  isLoading,
  receiveErrorCode,
  handleClick,
  txHash,
  swichToShare,
  walletIdToken,
  savePhoneNumber,
  setSavePhoneNumber,
  setAnswerInfoHandler
}) {
  const [phoneNumber, setPhoneNumber] = useState()
  const [check, setCheck] = useState(false)
  const [initialCountryCode, setInitialCountryCode] = useState("tw")
  const [copy1, setCopy1] = useState(false)

  const resetNFT = () => {
    setShowResult(null)
    setPhoneNumber()
    setCheck(false)
  }

  const getErrorDisplay = code => {
    switch (code) {
      case 4006:
        return "領過了"
      case 4008:
        return "系統忙碌中，請稍後再試"

      case 4010:
        return "電話號碼格式錯誤"

      default:
        return "系統忙碌中，請稍後再試"
    }
  }

  const isValidPhoneNumber = phoneNumber => {
    return parsePhoneNumber(`+${phoneNumber}`)?.isValid()
  }

  const getButtonState = (phoneNumber, check) => {
    if (!isValidPhoneNumber(phoneNumber) || !check) return "disabled"

    return ""
  }

  const getNFTClick = () => {
    setAnswerInfoHandler()
    if (!isValidPhoneNumber(phoneNumber) || !check) return
    handleClick(null, phoneNumber)
  }

  const getHiddenPhoneDisplay = phoneNumber => {
    let _phoneShow = phoneNumber?.replace(/^(\d{3})\d{5}(\d+)/, "$1*****$2")
    return _phoneShow
  }

  const handleChange = value => {
    setPhoneNumber(value)
    setSavePhoneNumber(value)
  }

  return (
    <Wrapper>
      <TitleWrapper>領取人物NFT</TitleWrapper>
      {!showResult ? (
        <>
          <h3>輸入手機號碼</h3>
          <p>NFT 將透過 KryptOGO Wallet 空投！</p>
          <FormWrapper>
            <PhoneInput
              autoFormat
              countryCodeEditable={false}
              country={initialCountryCode}
              onlyCountries={["tw", "us"]}
              placeholder="090-000-0000"
              required
              onChange={handleChange}
            />

            <CheckWrapper>
              <label className="container">
                <p>我已經閱讀並同意</p>
                <input
                  type="checkbox"
                  value="confirm"
                  onChange={() => setCheck(!check)}
                />
                <span className="checkmark"></span>
                <a href="">隱私權政策</a>
              </label>
            </CheckWrapper>
            <ButtonWrapper>
              <PanelButton
                type={getButtonState(phoneNumber, check)}
                title="送出"
                onClick={getNFTClick}
              />
            </ButtonWrapper>
          </FormWrapper>
        </>
      ) : (
        <>
          {(!receiveErrorCode || receiveErrorCode === 4006) && (
            <>
              {receiveErrorCode === 4006 ? (
                <h3>您已經領取過</h3>
              ) : (
                <>
                  <h3>已經發送至</h3>{" "}
                  {walletIdToken ? (
                    <h3>您的 KryptoGO Wallet</h3>
                  ) : (
                    <h3>+{getHiddenPhoneDisplay(savePhoneNumber)}</h3>
                  )}
                </>
              )}

              <p>下載 KryptoGO 立刻查看 NFT</p>
              <DownloadsWrapper>
                <a href="https://kryptogo.page.link/4HxW" target="blank">
                  <DownloadButtonWrapper>
                    <NextImg src={DownloadDeepLink} />
                  </DownloadButtonWrapper>
                </a>
                <CopyToClipboard
                  onCopy={() => {
                    setCopy1(true)
                    setTimeout(() => {
                      setCopy1(false)
                    }, 800)
                  }}
                  text={`${
                    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
                      ? "https://www.kryptogo.com/"
                      : "https://www-dev.kryptogo.com/"
                  }money-fortune?utm_source=app&utm_medium=fortune&utm_campaign=221118`}
                >
                  <DownloadButtonWrapper>
                    <PanelButton copy={copy1} type="shareButton" />
                  </DownloadButtonWrapper>
                </CopyToClipboard>
              </DownloadsWrapper>

              <a target="blank" href={`https://polygonscan.com/tx/${txHash}`}>
                {"點擊查看NFT傳送狀態"}
              </a>
              <ShareButton onClick={swichToShare}>或分享結果</ShareButton>
            </>
          )}
          {(receiveErrorCode === 4008 || receiveErrorCode === 4010) && (
            <>
              <h3>{getErrorDisplay(receiveErrorCode)}</h3>
              <BackButton
                onClick={() => {
                  setShowResult(false)
                  setShowPanel("close")
                  setPhoneNumber("")
                  setCheck(false)
                }}
              >
                <p>重新領取</p>
              </BackButton>
            </>
          )}
        </>
      )}
      {/* <p onClick={resetNFT}>重新</p> */}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 8px 30px;
  min-height: 200px;
  min-width: 330px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  * {
    margin: 0;
  }
  h3 {
    font-size: 20px;
  }
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 16px;
  }
  a {
    color: #00fff0;
    text-decoration: underline;
    cursor: pointer;
  }
`
const TitleWrapper = styled.h1`
  color: #00fff0;
  font-size: 24px;
  margin-bottom: 12px;
  text-shadow: 0 0 12px #00fff0;
`
const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  .react-tel-input {
    position: relative;
    .special-label {
      display: none;
    }
    .form-control {
      padding: 16px 16px 16px 58px;
      width: 100%;
      background-color: rgba(255, 255, 255, 0);
      border: 1px solid #00fff0;
      border-radius: 12px;
      color: #00fff0;
      font-size: 16px;
      &::placeholder {
        color: #00fff0;
        opacity: 0.8;
      }
    }
    .flag-dropdown {
      padding: 0;
      transform: translate(0%, -50%);
      top: 50%;
      left: 0;
      .country-list {
        width: 250px;
        .country-name {
          color: #000;
        }
      }
    }
    .selected-flag .arrow {
      border-top: #00fff0 4px solid;
      &.up {
        border-top: #00fff0 4px solid;
        border-bottom: none;
      }
      /* display: none; */
    }
  }
`
const Input = styled.input`
  padding: 16px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid #00fff0;
  border-radius: 12px;
  margin: 20px 0 0;
  color: #00fff0;
  font-size: 16px;
  &::placeholder {
    color: #00fff0;
    opacity: 0.8;
  }
`
const ButtonWrapper = styled.div`
  width: 100%;
  margin: 20px 0 0;
`
const CheckWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    display: inline-block;
  }

  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    padding-right: 0;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    height: 16px;
    width: 16px;
    border: solid 1px #00fff0;
  }

  .container input:checked ~ .checkmark {
    background-color: #00fff0;
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  .container input:checked ~ .checkmark:after {
    display: block;
  }

  .container .checkmark:after {
    left: 5px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid #000;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`
const DownloadsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 20px 0;
  gap: 12px;
  width: 100%;
  max-width: 200px;
  a {
    width: 100%;
  }
`
const DownloadButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  border: 1px solid #00fff0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  h3 {
    margin: 0;
  }
`

const BackButton = styled.div`
  width: 100%;
  margin-top: 20px;
  border: 1px solid #00fff0;
  padding: 16px;
  border-radius: 12px;
`
const ShareButton = styled.div`
  color: #00fff0;
  text-decoration: underline;
  cursor: pointer;
`
// const Wrapper = styled.div``
